<template>
	<div>
		<div class="filter-status">
			<button :class="buttonTunaiClass" tabindex="-1" @click="changeReport('tunai')">Tunai</button>
			<button :class="buttonFisikEmasClass" tabindex="-1" @click="changeReport('fisikEmas')">Fisik Emas</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'WithdrawalNav',
	props: {
		// reportToShow_prop: {
		// 	type: String,
		// 	default: 'tunai'
		// }
	},
	data() {
		return {

		}
	},
	computed: {
		accountLevel() {
			return this.$store.getters.getAccountLevel
		},

		withdrawalToShow() {
			return this.$store.state.withdrawalToShow
		},

		activeTunai() {
			return this.withdrawalToShow == 'tunai' ? true : false
		},
		activeFisikEmas() {
			return this.withdrawalToShow == 'fisikEmas' ? true : false
		},

		buttonTunaiClass() {
			return {
				'c-btn-active': this.activeTunai
			}
		},
		buttonFisikEmasClass() {
			return {
				'c-btn-active': this.activeFisikEmas
			}
		}
	},

	created() {
		if (this.accountLevel == 'client' && this.withdrawalToShow == 'clients') {
			this.$store.commit('setWithdrawalToShow_mut', 'tunai')
		}
	},

	methods: {
		changeReport(value) {
			this.$store.commit('setWithdrawalToShow_mut', value)
		}
	}
}
</script>

<style scoped>
.filter-status {
	background-color: #1e1e2c;
	display: inline-block;
	padding: 2px;
	border: 1px solid rgba(255, 255, 255, 0.25);
	border-radius: 4px;
	height: auto;
	vertical-align: middle;
}

button {
	background-color: #1e1e2c;
	color: white;
	border: 0px;
	/*border-radius: 5px;*/
	padding: 5px 15px;
	height: 2.375em;
	font-weight: 700;
}

button:hover {
	/* background-color: #3b3b56; */
	cursor: pointer;
	filter: brightness(125%);
}

button:active {
	background-color: #2e3d61;
}

.c-btn-active {
	background-color: var(--color-theme);
	border-radius: 2px;
}
</style>